// extracted by mini-css-extract-plugin
export default {"main":"Main_main__zVvQX","banner":"Main_banner__0m+v4"};